module.exports = __webpack_public_path__ + "img/ywt_list_img3.ea1a125.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/saasIntroduction/ywt_list_img3.png
// module id = vyOg
// module chunks = 136